<div class="container-fluid">
  <app-submenu-tabs section="CUSTOMER"></app-submenu-tabs>
  <router-outlet></router-outlet>    
</div>
